module.exports = __webpack_public_path__ + "media/checkout_application_v3/assets/images/flag_sv_swedish-3dc09b9e96cefa2fa42b7a31d16a5288.svg";